var React = require('react');

function ArrowHead (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.68292222,8 L0.240743398,1.65079137 C-0.118678753,1.23146553 -0.0701172162,0.600165549 0.349208627,0.240743398 C0.768534469,-0.118678753 1.39983445,-0.0701172162 1.7592566,0.349208627 L7.7592566,7.34920863 C8.0802478,7.72369836 8.0802478,8.27630164 7.7592566,8.65079137 L1.7592566,15.6507914 C1.39983445,16.0701172 0.768534469,16.1186788 0.349208627,15.7592566 C-0.0701172162,15.3998345 -0.118678753,14.7685345 0.240743398,14.3492086 L5.68292222,8 Z","id":"Line"}));
}

ArrowHead.defaultProps = {"width":"8px","height":"16px","viewBox":"0 0 8 16","version":"1.1"};

module.exports = ArrowHead;

ArrowHead.default = ArrowHead;
